import { FaStore, FaFacebookF, FaInstagram, FaTwitter } from "react-icons/fa";
import "./Footer.scss";
import { Branding } from '../services/misc';


const Footer = () => {
	console.log(Branding().Background);
	return (
		<footer className="site-footer">
			<div className="site-footer__container">
				<div className="site-footer__grid">
					<div className="site-footer__brand">
						<div className="site-footer__brandRow">
							<div className="site-footer__brandIcon" aria-hidden="true">
								<FaStore />
							</div>
							<h3 className="site-footer__brandName">{Branding().Headline}</h3>
						</div>

						{/* <p className="site-footer__brandText">
							Sveriges mest innovativa plattform för obemannad handel. Framtiden
							är här, och den är alltid öppen.
						</p> */}


					</div>

					<div className="site-footer__col">
						<h4 className="site-footer__heading">Företag</h4>
						<div className="site-footer__text">CloudSolution Nordic AB</div>
						<div className="site-footer__text">SE559213875301</div>
					</div>

					<div className="site-footer__col">
						<h4 className="site-footer__heading">Adress</h4>
						<div className="site-footer__text">Stridsvagnsvägen 14</div>
						<div className="site-footer__text">SE-291 39 Kristianstad</div>
						<div className="site-footer__text">Sweden</div>
					</div>

					<div className="site-footer__col">
						<h4 className="site-footer__heading">Kontakt</h4>
						<div className="site-footer__text">Email: {Branding().Mail}</div>
						<div className="site-footer__text">Phone: +46 702 37 68 86</div>
					</div>

				</div>

				<div className="site-footer__bottom">
					<p>© {new Date().getFullYear()} {Branding().Headline}. Alla rättigheter förbehållna.</p>

					<div className="site-footer__bottomLinks">
						<a href="#">Användarvillkor</a>
					</div>
				</div>
			</div>
		</footer>
	);
};

export default Footer;